import './App.css';
import './Sidebar/Sidebar.css';
import Header from './Header/Header';
import App from './App';

import React, { useEffect, useMemo } from 'react';
import {
    useMsalAuthentication,
    useIsAuthenticated,
    useMsal,
} from '@azure/msal-react';
import { InteractionStatus, InteractionType } from '@azure/msal-browser';
import { useDispatch } from 'react-redux';
import { actions } from '../context';

const shrinkHeight = 1200;

const AppAuth = ({ msalClientScope }) => {

    const authenticationRequest = useMemo(() => ({
        scopes: [msalClientScope],
    }), [msalClientScope]);

    const dispatch = useDispatch();

    const isAuthenticated = useIsAuthenticated();

    const { login, error } = useMsalAuthentication(
        InteractionType.Redirect,
        authenticationRequest
    );

    const { inProgress } = useMsal();
    // when an error occurs it yells about app auth setting state while the msal provider is rendering
    const beginLogin = useMemo(() => {
        // If we can click the login button then something might be wrong with the redirect.
        // So we will dispatch the login action which will clear the cookies and session storage before trying to redirect again.
        // pass the login function from msal so it knows what to do.
        if (!error && !isAuthenticated && inProgress === InteractionStatus.None) {
            dispatch(
                actions.users.sessionLogin(
                    login,
                    InteractionType.Redirect,
                    authenticationRequest
                )
            );
        }

        return () => {
            if (!isAuthenticated && inProgress === InteractionStatus.None) {
                dispatch(
                    actions.users.sessionLogin(
                        login,
                        InteractionType.Redirect,
                        authenticationRequest
                    )
                );
            }
        }
        // eslint-disable-next-line
    }, [isAuthenticated, inProgress]);

    // Fetch data needed to run the app
    useEffect(() => {
        if (!error && isAuthenticated && inProgress === InteractionStatus.None) {
            dispatch(actions.auth.setAccountInfo());
            dispatch(actions.pims.fetchAllPims());
            dispatch(
                actions.toggle.toggleSidebarOpen(
                    window.innerWidth >= shrinkHeight
                )
            );
        }
        // eslint-disable-next-line
    }, [isAuthenticated, error, inProgress]);

    return (
        <>
            <Header isAuthenticated={isAuthenticated} login={beginLogin} />
            {/* these next two lines fix the header issues I was having. rj 04/21*/}
            <br />
            <span>&nbsp;</span>
            <App beginLogin={beginLogin} error={error} />
        </>
    );
};

export default AppAuth;
